import React, { useState, useEffect, useRef } from "react";
import {
  Logo,
  bell,
  AccountSetting,
  LogOutIcon,
  ManageBeni,
  MobileHeader,
  NotificationGlobe,
} from "./../../Public/assets/index";
import Lottie from "react-lottie";
import { useMatch, useNavigate } from "react-router-dom";
import { getSession } from "./../../axios.config";
import { logout } from "./../../api";
import { useOverview } from "./../../hooks";
import {
  clearSession,
  getInitials,
  lottieOptions,
} from "./../../Utils/helperFunction";
import InvestingBanner from "./investingBanner";
import InvestingICon from "../../Public/assets/investing/Investing_icon.svg";
import { useTheme } from "../../Context/Theme";

const usePreventScroll = (isOpen) => {
  useEffect(() => {
    if (isOpen) {
      const originalStyle = window.getComputedStyle(document.body).overflow;
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = originalStyle;
      };
    }
  }, [isOpen]);
};

const ProtectedLayout = ({
  children,
  noToggle = true,
  notVerified = false,
}) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const dropdownRef = useRef(null);
  const mobileMenuRef = useRef(null);
  const user = JSON.parse(getSession("userId"));
  const USERName = user?.name;
  const matchHome = useMatch("/home");
  const { getThemeLogo } = useTheme();
  const dynamicLogo = getThemeLogo();

  usePreventScroll(mobileMenuOpen);

  const [showNotifications, setShowNotifications] = useState(false);
  const notificationRef = useRef(null);
  const [investingOpen, setInvestingOpen] = useState(false);
  const investingRef = useRef(null);
  const investingBannerRef = useRef(null);

  const handleLogout = async () => {
    await logout();
    clearSession();
    navigate("/");
  };

  // To Close notification model when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        notificationRef.current &&
        !notificationRef.current.contains(event.target)
      ) {
        setShowNotifications(false);
      }
      if (
        investingRef.current &&
        !investingRef.current.contains(event.target) &&
        (!investingBannerRef.current ||
          !investingBannerRef.current.contains(event.target))
      ) {
        setInvestingOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const { useGlobalAccount, setCurrentFlow, setIsOpen, setActiveTab } =
    useOverview();

  const { data: globalData } = useGlobalAccount(noToggle);

  const menuItems = [
    {
      icon: AccountSetting,
      text: "Account Settings",
      onClick: () => {
        navigate("/account");
      },
    },
    {
      icon: ManageBeni,
      text: "Manage Beneficiaries",
      onClick: () => {
        setCurrentFlow("beniList");
        setIsOpen(true);
      },
    },
    // {
    //   icon: Managebenificary,
    //   text: "Reports & Statement",
    // },
    {
      icon: LogOutIcon,
      text: "Logout",
      className: " text-[#FF0004] overflow-hidden",
      onClick: handleLogout,
    },
  ];

  const notVerifiedMenuItems = [
    {
      icon: AccountSetting,
      text: "Account Settings",
      onClick: () => {
        navigate("/account");
      },
    },
    // {
    //   icon: <FileText />,
    //   text: "Manage Beneficiaries",
    // },
    // {
    //   icon: Managebenificary,
    //   text: "Reports & Statement",
    // },
    {
      icon: LogOutIcon,
      text: "Logout",
      className: " text-[#FF0004] overflow-hidden",
      onClick: handleLogout,
    },
  ];

  // Close dropdown when clicking outside

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
      if (
        mobileMenuRef.current &&
        !mobileMenuRef.current.contains(event.target)
      ) {
        setMobileMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="flex flex-col overflow-auto">
      <nav className="fixed top-0 z-50 w-full bg-white shadow-mobileHeaderShadow md:shadow-sm">
        <div className="h-[63px] lg:h-[80px] px-6 xl:px-40 flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <img
              src={Logo}
              alt=""
              className=" !w-[75px] md:!w-[135px] lg:w-auto cursor-pointer !min-w-[100px] !min-h-[30px]"
              onClick={() => {
                if (!matchHome) {
                  navigate(-1);
                }
                setActiveTab("overview");
              }}
            />
          </div>

          {noToggle && (
            <div className="relative items-center hidden space-x-4 sm:flex">
              <div
                className="relative flex items-center cursor-pointer"
                ref={investingRef}
                onClick={() => setInvestingOpen((prev) => !prev)}
              >
                <div className="font-[geomanistbook] font-normal text-[14px] leading-[20px] text-center tracking-[0px] text-[#3C404A]">
                  Borderless Investing
                </div>
                <svg
                  className="w-4 h-4 text-gray-600 hover:pointer"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </svg>
                {investingOpen && <InvestingBanner ref={investingBannerRef} />}
              </div>

              <div className="relative" ref={notificationRef}>
                <button
                  className="p-2 rounded-full hover:bg-gray-100"
                  onClick={() => setShowNotifications(!showNotifications)}
                >
                  <img src={bell} alt="" className="w-5 h-5 text-gray-600" />
                </button>
                {showNotifications && (
                  <div className="absolute right-0 z-50 py-8 mt-2 bg-white border border-gray-200 rounded-lg shadow-lg w-80">
                    <div className="flex flex-col justify-center p-4 text-center gap-3items-center ">
                      <Lottie
                        options={lottieOptions(NotificationGlobe)}
                        width={120}
                        height={120}
                        loop={true}
                      />

                      <h3 className="mt-5 mb-2 text-xl font-medium text-gray-800">
                        You're all caught up!
                      </h3>
                      <p className="text-sm text-gray-500">
                        New notifications will show up here.
                      </p>
                    </div>
                  </div>
                )}
              </div>

              <div
                className="relative flex items-center space-x-2 hover:pointer"
                onClick={() => setDropdownOpen((prev) => !prev)}
                ref={dropdownRef}
              >
                <button className="p-2 rounded-full font-geomanistMedium text-greyish bg-greyShade">
                  {getInitials(USERName)}
                </button>
                <svg
                  className="w-4 h-4 text-gray-600 hover:pointer"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>

              {dropdownOpen && (
                <div
                  className="absolute top-12 right-0 rounded-[10px] shadow-headerShadow"
                  ref={dropdownRef}
                >
                  <div className="w-[232px] bg-white rounded-lg overflow-hidden shadow-lg">
                    {!notVerified && (
                      <div className="px-[10px] pt-4 pb-1 gap-0.5">
                        <div className="text-[#475467] leading-[20px] font-geomanistBold text-[16px]">
                          {USERName}
                        </div>
                        <div className="leading-[28px] text-[16px] text-[#767C8F]">
                          ******{globalData?.data?.vendorAccountNo?.slice(-4)}
                        </div>
                      </div>
                    )}
                    {!notVerified ? (
                      <div className="">
                        {menuItems.map((item, index) => (
                          <button
                            key={index}
                            className={`w-full border-t flex items-center gap-2 py-4 pl-[10px] hover:bg-gray-50 font-geomanistBold text-left text-[16px] leading-[21px] text-[#717789] ${
                              item.className || ""
                            }`}
                            onClick={item.onClick}
                          >
                            <img src={item.icon} alt="" />
                            {item.text}
                          </button>
                        ))}
                      </div>
                    ) : (
                      <div className="">
                        {notVerifiedMenuItems.map((item, index) => (
                          <button
                            key={index}
                            className={`w-full border-t flex items-center gap-2 py-4 pl-[10px] hover:bg-gray-50 font-geomanistBold text-left text-[16px] leading-[21px] text-[#717789] ${
                              item.className || ""
                            }`}
                            onClick={item.onClick}
                          >
                            <img src={item.icon} alt="" />
                            {item.text}
                          </button>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          )}

          {noToggle && (
            <div className="relative flex items-center space-x-4 sm:hidden">
              {/* Borderless Investing Icon for mobile view */}
              {/* <div
                className="relative flex items-center cursor-pointer"
                ref={investingRef}
                onClick={() => setInvestingOpen((prev) => !prev)}
              >
                <img
                  src={InvestingICon}
                  alt="Borderless Investing"
                  className="w-6 h-6 mr-2"
                />
                {investingOpen && <InvestingBanner ref={investingRef} />}
              </div> */}
              <div className="relative" ref={notificationRef}>
                <button
                  className="p-2 rounded-full hover:bg-gray-100"
                  onClick={() => setShowNotifications(!showNotifications)}
                >
                  <img src={bell} alt="" className="w-5 h-5 text-gray-600" />
                </button>
                {showNotifications && (
                  <div className="absolute z-50 mt-2 bg-white border border-gray-200 rounded-lg shadow-lg -right-14 w-80">
                    <div className="flex flex-col items-center justify-center p-4 text-center ">
                      <Lottie
                        options={lottieOptions(NotificationGlobe)}
                        width={120}
                        height={120}
                        loop={true}
                      />

                      <h3 className="mb-2 text-xl font-medium text-gray-800">
                        You're all caught up!
                      </h3>
                      <p className="text-sm text-gray-500">
                        New notifications will show up here.
                      </p>
                    </div>
                  </div>
                )}
              </div>
              <button
                className="p-2"
                onClick={() => setMobileMenuOpen((prev) => !prev)}
              >
                <img src={MobileHeader} alt="" className="w-6 h-6" />
              </button>
            </div>
          )}
        </div>

        {/* Mobile Navigation Menu */}
        {mobileMenuOpen && (
          <div
            className="fixed inset-0 bg-black bg-opacity-50 sm:hidden"
            onClick={() => setMobileMenuOpen(false)}
          >
            <div
              ref={mobileMenuRef}
              className="absolute top-0 right-0 w-64 h-full transition-transform duration-300 ease-in-out transform bg-white shadow-lg"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="p-4">
                {!notVerified && (
                  <div className="pb-4 mb-4 border-b">
                    <div className="text-[#475467] font-geomanistBold text-lg">
                      {USERName}
                    </div>
                    <div className="text-[#767C8F] text-sm">
                      ******{globalData?.data?.vendorAccountNo?.slice(-4)}
                    </div>
                  </div>
                )}
                <div className="space-y-2">
                  {(notVerified ? notVerifiedMenuItems : menuItems).map(
                    (item, index) => (
                      <button
                        key={index}
                        className={`w-full flex items-center gap-3 py-3 px-2 rounded-lg hover:bg-gray-50 font-geomanistBold text-left text-[16px] ${
                          item.className || "text-[#717789]"
                        }`}
                        onClick={() => {
                          setMobileMenuOpen(false);
                          item.onClick?.();
                        }}
                      >
                        <img src={item.icon} alt="" className="w-5 h-5" />
                        {item.text}
                      </button>
                    ),
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </nav>
      {children}
    </div>
  );
};

export default ProtectedLayout;
